import type { WalletTransactionsListResult } from "@/modules/wallet/domain/repo/transactions";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type RefundItem = WalletTransactionsListResult["data"][number];

export type CreateRefundBody = {
  walletId: string;
  amount: number;
  currency: "LAK" | "THB" | "USD";
  reason?: string;
  referenceType?: "order" | "job";
  referenceId?: string;
};

export const refundApi = {
  async list(query: OffsetPageQueryDTO): Promise<WalletTransactionsListResult> {
    const url = new URL(`${config.apiUrl}/refund`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<WalletTransactionsListResult>(url.toString());
  },

  async create(
    body: CreateRefundBody,
  ): Promise<{ ok: boolean; transactionId: string }> {
    return fetcher.post<{ ok: boolean; transactionId: string }>(
      `${config.apiUrl}/refund`,
      body,
    );
  },
};
